import styled from 'styled-components'
import { Icon20 } from 'cio-design-library/icons'
import { Colors, Spacing } from 'cio-design-library/design-tokens'

import Media from 'builder/styles/media'
import { Typography, FontWeights } from 'builder/styles/typography'

import { VaulDrawer } from 'builder/components/DrawerModal'
import * as SimpleForm from 'builder/components/SimpleForm'
import { ButtonTheme, ButtonV2 } from 'builder/components/Button'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`

export const InputRow = styled(SimpleForm.Row)`
  margin-bottom: ${Spacing.S};
`

export const Container = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: column;
  width: 544px;

  padding: ${Spacing.L};
  border-radius: ${Spacing.S};
  background-color: ${Colors.White};
  gap: ${Spacing.M};

  ${Media.Phone`
    width: 100%;
  `};
`

export const HeaderContainer = styled.div`
  display: flex;
  gap: ${Spacing.XS};
  justify-content: space-between;
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.XS};
`

export const InfoHeader = styled.h2`
  ${Typography.S};
  ${FontWeights.DemiBold};

  color: ${Colors.Neutral90};
`

export const InfoDescription = styled.p`
  ${Typography.Body};
  ${FontWeights.Regular};

  color: ${Colors.Neutral50};
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: ${Spacing['2XS']};
  justify-content: flex-end;
  margin-top: ${Spacing.S};

  ${Media.Phone`
    flex-direction: column-reverse;
    margin-top: 200px;
  `};
`

export const IconContainer = styled.div`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CloseIcon = styled(Icon20.Close)`
  color: ${Colors.Neutral50};
`

export const CloseButton = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${Colors.Neutral10};
  cursor: pointer;

  &:hover {
    background-color: ${Colors.Blue10};
    color: ${Colors.Blue50};
  }
`

export const ConfirmButton = styled(ButtonV2)``
export const CancelButton = styled(ButtonV2).attrs({
  theme: ButtonTheme.ghost,
})``

export const MobileHandle = styled(VaulDrawer.Handle)`
  margin: 8px auto 4px;
  background: ${Colors.Neutral30};
`

export const JobTitleList = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacing['2XS']};
  flex-wrap: wrap;
`
